export enum EmploymentType {
    ON_PAYROLL = "ON_PAYROLL",
    COMMISSION = "COMMISSION",
    NOT_APPLICABLE = "NOT_APPLICABLE"
}

export default interface User {
    username: string,
    user_role: string,
    owner_type: string,
    owner_name: string,
    name: string,
    address: string,
    email: string,
    phone_number: string,
    created_date: string,
    created_by: string,
    parent_username: string,
    is_temporarily_locked: boolean,
    last_password_updated_date: string,
    status: string;
    employment_type?: EmploymentType | null;
}

export interface UserRequest {
    name: string;
    password: string | null;
    email: string;
    phone_number: string;
    user_role: string;
    address: string;
    parent_username: string;
    is_temporarily_locked: boolean;
    employment_type?: EmploymentType | null;
}

export enum UserStatus {
    PENDING_UPDATE = "PENDING_UPDATE",
    PENDING_REVIEW = "PENDING_REVIEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
};